export { default } from './StaticPageText';
